// extracted by mini-css-extract-plugin
export default {"item":"GalleryItemBlock_item__dlSGO"};